<template>
  <MobileAuth ref="mobileAuth" :actionType="'SET'">
    <template v-slot:titleArea></template>

    <template v-slot:msgArea>
      <div class="msg">
        <div>이제, 새로운 전화번호로 인증하시면 이전의 전화번호로</div>
        <div>등록된 계정을 이어서 사용하실 수 있습니다.</div>
      </div>
    </template>

    <template v-slot:btnArea="btnAreaProps">
      <div class="btm_btn">
        <button
          class="btn"
          :disabled="!btnAreaProps.isAvailable"
          @click="change()"
        >
          변경하기
        </button>
      </div>
    </template>
  </MobileAuth>
</template>
<script>
import MobileAuth from './components/MobileAuth';
import { mapActions as userMapActions } from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import { authMapActions, authTypes } from '@common/store/modules';
export default {
  components: {
    MobileAuth,
  },
  data() {
    return {
      username: '',
      password: '',
    };
  },
  created() {
    this.username = this.$route.query.email;
    this.password = this.$route.query.authNumber;

    if (!this.username || !this.password) {
      this.$router.push({ name: 'Auth.EmailConfirm' });
    }
  },
  computed: {},
  methods: {
    ...authMapActions([authTypes.LOGIN]),
    ...userMapActions([userTypes.UPDATE_MOBILE_NUMBER_ME, userTypes.FETCH_ME]),
    change() {
      this.$refs.mobileAuth.handleAuthConfirm((mobileNumber, authNumber) => {
        let loginParam = {
          username: this.username,
          password: this.password,
          roles: 11,
        };

        this[authTypes.LOGIN](loginParam)
          .then(() => {
            let params = {
              mobileNumber: mobileNumber,
              code: authNumber,
            };
            this[userTypes.UPDATE_MOBILE_NUMBER_ME](params).then(() => {
              this[userTypes.FETCH_ME]().then(response => {
                if (!response.nickname) {
                  this.$router.push({ name: 'Auth.Profile' });
                } else {
                  if (!response.emdAreaId) {
                    this.$router.push({ name: 'Auth.Region' });
                  } else {
                    this.$router.push({ name: 'Home' });
                  }
                }
              });
            });
          })
          .catch(() => {});
      });
    },
  },
};
</script>
